module.exports = __webpack_public_path__ + "img/car_shina2_17.e973394f.jpg";